<template>
  <div>
    <table class="mcr-info-table mb-0">
      <colgroup>
        <col style="width: 15%;">
        <col style="width: 35%;">
        <col style="width: 15%;">
        <col style="width: 35%;">
      </colgroup>
      <tbody>
        <tr>
          <td class="mcr-label">Subject</td>
          <td>
            <span v-if="!isHeaderLoading">{{ mcrHeader.subject }}</span>
            <Skeleton v-else height="1.5rem"></Skeleton>
          </td>
          <td class="mcr-label">Company</td>
          <td>
            <span v-if="!isHeaderLoading">{{ mcrHeader.company }}</span>
            <Skeleton v-else height="1.5rem"></Skeleton>
          </td>
        </tr>
        <tr>
          <td class="mcr-label">Status</td>
          <td>
            <span v-if="!isHeaderLoading" class="text-capitalize">{{ formatStatus(mcrHeader.status) }}</span>
            <Skeleton v-else height="1.5rem"></Skeleton>
          </td>
          <td class="mcr-label">Total Item</td>
          <td>
            <span v-if="!isHeaderLoading">{{ stateAllMcrItem.length }}</span>
            <Skeleton v-else height="1.5rem"></Skeleton>
          </td>
        </tr>
        <tr>
          <td class="mcr-label">Type</td>
          <td>
            <span v-if="!isHeaderLoading">{{ formatType(mcrHeader.type) }}</span>
            <Skeleton v-else height="1.5rem"></Skeleton>
          </td>
          <td class="mcr-label">MCR Number</td>
          <td>
            <span v-if="!isHeaderLoading">{{ mcrHeader.mcr_number }}</span>
            <Skeleton v-else height="1.5rem"></Skeleton>
          </td>
        </tr>
        <tr>
          <td class="mcr-label">Created By</td>
          <td>
            <span v-if="!isHeaderLoading">{{ mcrHeader.user_created?.name || mcrHeader.created_by }}</span>
            <Skeleton v-else height="1.5rem"></Skeleton>
          </td>
          <td class="mcr-label">Created At</td>
          <td>
            <span v-if="!isHeaderLoading">{{ mcrHeader.created_at ? formatDate(mcrHeader.created_at) : '' }}</span>
            <Skeleton v-else height="1.5rem"></Skeleton>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import moment from 'moment';
import 'moment/locale/id';
import { mapState } from 'vuex';
import api from "@/helpers/api";
import formConfigService from '@/services/materialCatalogingRequest/formConfigService';

export default {
  data() {
    return {
      typeOptions: [],
    };
  },
  computed: {
    ...mapState({
      mcrHeader: (state) => state.mcr.mcrHeader,
      isHeaderLoading: (state) => state.mcr.isLoading.header,
      stateAllMcrItem: (state) => state.mcr.allMcrItem || [],
    }),
  },
  mounted() {
    this.fetchTypeOptions();
  },
  methods: {
    async fetchTypeOptions() {
      try {
        const response = await api(this, formConfigService.get('mcr_type'), false);
        const types = response?.data?.data || [];
        this.typeOptions = types.map(t => ({
          label: `${t.code} - ${t.description}`,
          value: t.code
        }));
      } catch (error) {
        console.error("Failed to fetch MCR types:", error);
      }
    },
    formatDate(val) {
      return moment(val).locale('id').format('DD MMMM YYYY [:] HH.mm');
    },
    // Status MCR untuk tampilan: "_" jadi spasi (mis. send_back -> "send back"); huruf kapital tiap kata dari class text-capitalize.
    formatStatus(status) {
      return String(status || "").replace(/_/g, " ");
    },
    formatType(type) {
      if (!type) return "";

      // Cek secara dinamis dari API (MCR001, MCR002, dsb)
      const option = this.typeOptions.find(opt => opt.value === type);
      if (option) return option.label;

      return type;
    },
  },
};
</script>
<style scoped>
.mcr-section-title {
  color: #1e2d6e;
  font-size: 0.95rem;
}

.mcr-info-table {
  width: 100%;
  border-collapse: collapse;
}

.mcr-info-table td {
  border: 1px solid #dee2e6;
  padding: 10px 16px;
  vertical-align: middle;
  font-size: 0.875rem;
  color: #2c3e50;
}

.mcr-label {
  font-weight: 600;
  color: #1e2d6e;
  background-color: #f8f9fc;
  white-space: nowrap;
}
</style>
